export default __webpack_public_path__ + "static/media/menu.9d1732f0.svg";